import { useEffect, useState } from "react";
import { createRoot } from "react-dom/client";

import { Root } from "./Root";
import { AdminFeatureLocalizationRuntime } from "./features/admin/AdminFeatureLocalizationRuntime";
import { AdminShellLocalizationRuntime } from "./features/admin/AdminShellLocalizationRuntime";
import { PlatformBrandingSettingsPortal } from "./features/admin/PlatformBrandingSettingsPortal";
import { AdminDateLocalizationRuntime } from "./i18n/AdminDateLocalizationRuntime";
import { ProfileLocalizationRuntime } from "./i18n/ProfileLocalizationRuntime";
import { PublicSurfaceFoundation } from "./i18n/PublicSurfaceFoundation";
import { WorkspaceLocaleGate } from "./i18n/WorkspaceLocaleGate";
import { WorkspaceLocaleRuntime } from "./i18n/WorkspaceLocaleRuntime";
import { WorkspaceThemeRuntime } from "./i18n/WorkspaceThemeRuntime";
import { NAVIGATION_EVENT, currentPath } from "./navigation";
import { GlobalPlatformBranding } from "./ui/PlatformBranding";
import { ProminentFeedbackRuntime } from "./ui/ProminentFeedbackRuntime";
import "./styles/global.css";
import "./styles/platform-ui-tokens.css";
import "./styles/platform-ui-foundation.css";
import "./styles/platform-ui.css";
import "./styles/login.css";
import "./styles/login-autofill.css";
import "./styles/public-surface-foundation.css";
import "./styles/admin.css";
import "./styles/admin-form-system.css";
import "./styles/setup.css";
import "./styles/nontechnical-forensic-pilot.css";
import "./styles/workspace-theme-compat.css";
import "./styles/admin-dark-audit.css";
import "./styles/admin-detail-repairs.css";

function ApplicationRuntime() {
  const [path, setPath] = useState(currentPath);

  useEffect(() => {
    const sync = () => setPath(currentPath());
    window.addEventListener("popstate", sync);
    window.addEventListener(NAVIGATION_EVENT, sync);
    return () => {
      window.removeEventListener("popstate", sync);
      window.removeEventListener(NAVIGATION_EVENT, sync);
    };
  }, []);

  return (
    <>
      <GlobalPlatformBranding />
      <PlatformBrandingSettingsPortal path={path} />
      <WorkspaceLocaleRuntime path={path} />
      <WorkspaceThemeRuntime path={path} />
      <AdminShellLocalizationRuntime path={path} />
      <AdminFeatureLocalizationRuntime path={path} />
      <AdminDateLocalizationRuntime path={path} />
      <ProfileLocalizationRuntime path={path} />
      <PublicSurfaceFoundation path={path} />
      <ProminentFeedbackRuntime />
      <WorkspaceLocaleGate path={path}>
        <Root />
      </WorkspaceLocaleGate>
    </>
  );
}

const root = document.getElementById("root");
if (!root) throw new Error("root element is missing");
createRoot(root).render(<ApplicationRuntime />);
